import React, { useState } from "react";
import { Popup, Marker, Tooltip } from "react-leaflet";
import { createCustomPieChartMarker } from "./CustomMarker";
import { useSelectedMapSystems } from "../../hooks/useCloudSelectors";
import SingleSystem from "./SingleSystem";
import SensorMarker from "./SensorMarker";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import PopupContent from "./PopupContent";

const CustomerMarker = ({ customer }) => {
  const position = [customer.gpsLat, customer.gpsLong];


  const selectedMapSystems = useSelectedMapSystems();
  console.log("selectedMapSystems", selectedMapSystems);

  const systemsOfCustomer = selectedMapSystems.filter(
    (sys) =>
      sys.customerId === customer.customerId &&
      sys.customerName === customer.customerName &&
      sys.solutionType !== "lora"
  );
  const loraSystemsOfCustomer = selectedMapSystems.filter(
    (sys) =>
      sys.customerId === customer.customerId &&
      sys.customerName === customer.customerName &&
      sys.solutionType === "lora"
  );

  console.log("loraSystemsOfCustomer", loraSystemsOfCustomer);

  const [systemsWithAlarms, setSystemsWithAlarms] = useState({});

  const redSystems = Object.keys(systemsWithAlarms).filter(
    (key) =>
      systemsWithAlarms[key] === "red" &&
      systemsOfCustomer.findIndex((sys) => sys.deviceId === key) > -1
  );
  const orangeSystems = Object.keys(systemsWithAlarms).filter(
    (key) =>
      systemsWithAlarms[key] === "orange" &&
      systemsOfCustomer.findIndex((sys) => sys.deviceId === key) > -1
  );

  const redLoraSystems = Object.keys(systemsWithAlarms).filter(
    (key) =>
      systemsWithAlarms[key] === "red" &&
      loraSystemsOfCustomer.findIndex((sys) => sys.deviceId === key) > -1
  );
  const orangeLoraSystems = Object.keys(systemsWithAlarms).filter(
    (key) =>
      systemsWithAlarms[key] === "orange" &&
      loraSystemsOfCustomer.findIndex((sys) => sys.deviceId === key) > -1
  );

  return (
    <>
      {systemsOfCustomer.map((sys) => (
        <SingleSystem
          system={sys}
          key={sys.deviceId}
          setSystemsWithAlarms={setSystemsWithAlarms}
        />
      ))}
      {loraSystemsOfCustomer.map((sys) => (
        <SingleSystem
          system={sys}
          key={sys.deviceId}
          setSystemsWithAlarms={setSystemsWithAlarms}
        />
      ))}
      {systemsOfCustomer.length > 0 &&
        <Marker
          position={position}
          icon={createCustomPieChartMarker(
            redSystems.length,
            orangeSystems.length,
            systemsOfCustomer.length - redSystems.length - orangeSystems.length,
            systemsOfCustomer.length,
            56,
            36
          )}
        >
          <Tooltip direction="left">{customer.customerName}</Tooltip>
          <Popup autoPan={false} className="marker-popup" maxWidth={900}>
            <Box>
              <Grid container sx={{ flexWrap: "nowrap" }}>
                {systemsOfCustomer.map((item) => (
                  <PopupContent
                    item={item}
                    key={`${item.deviceId}Content`}
                    systemColor={systemsWithAlarms[item.deviceId]}
                  />
                ))}
              </Grid>
            </Box>
          </Popup>
        </Marker>
      }

      {
        loraSystemsOfCustomer.map((sys) => (
          <SensorMarker
            sys={sys}
            key={sys.deviceId}
          />
        ))
      }
    </>
  );
};

export default CustomerMarker;
